// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__Gs6K1","error":"Textarea_error__3jwou","readonly":"Textarea_readonly__376PD","disabled":"Textarea_disabled__3_z5c"};